import React, { useState } from "react";
import { AiOutlinePlusCircle, AiOutlineMinusCircle,AiFillCaretDown,AiFillCaretUp } from "react-icons/ai";
import PropTypes from "prop-types";
import "./Accordion.scss";

const Accordion = ({expanded,useArrows=false,children}) => {
  const [isActive, setIsActive] = useState(expanded);

  return (
    <div className="accordion-item">
      <div
        className={`accordion-title ${isActive ? "expanded" : "collapsed"}`}
        onClick={(e) => {
          e.preventDefault();
          setIsActive(!isActive);
        }}
      >
        {children[0]}
        <button>
          {isActive ? (useArrows ?  <AiFillCaretDown/>:<AiOutlineMinusCircle />) : (useArrows ? <AiFillCaretUp/>:<AiOutlinePlusCircle />)}
        </button>
      </div>
      <div
        style={isActive ? {} : { display: "none" }}
        className="accordion-content"
      >
        {children[1]}
      </div>
    </div>
  );
};

Accordion.propTypes = {
  expanded: PropTypes.bool.isRequired,
  children: PropTypes.arrayOf(PropTypes.element),
};

export default Accordion;
